import { getRealname, verificationGenerateToken, verificationQuery } from '@/http/authentication'
import { Toast } from 'vant'

const authenticationStore = {
  namespaced: true,
  state: {
    authenticationInfo: {}, // 实名信息
    accessToken: '', // 人脸token
    accessTokenInfo: null, // 人脸token的其他信息
    collectInfo: null, // 采集信息
    appVerificationCode: '', // App核验状态
    verificationReturnUrl: '' // App核验以后返回的地址
  },
  mutations: {
    SET_AUTHENTICATIONINFO: (state, data) => {
      state.authenticationInfo = data
    },
    SET_ACCESSTOKEN: (state, accessToken) => {
      state.accessToken = accessToken
    },
    SET_ACCESSTOKENINFO: (state, info) => {
      state.accessTokenInfo = info
    },
    SET_COLLECTINFO: (state, info) => {
      state.collectInfo = info
    },
    SET_APPVERIFICATIONCODE: (state, status) => {
      state.appVerificationCode = status
    },
    SET_VERIFICATIONRETURNURL: (state, url) => {
      state.verificationReturnUrl = url
    }
  },
  actions: {
    // 查询登录用户的企业实名信息
    fetchRealname ({ commit }, params) {
      return new Promise((resolve, reject) => {
        getRealname(params).then(res => {
          if (!res) return
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 人脸核验生成accesstoken
    fetchVerificationGenerateToken ({ commit }, params) {
      return new Promise((resolve, reject) => {
        verificationGenerateToken(params).then(res => {
          if (!res) return
          if (res.success) {
            commit('SET_ACCESSTOKEN', res.data.accessToken)
            resolve(res.data)
          } else {
            Toast.fail(res.resMsg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 人脸核验结果查询
    fetchVerificationQuery ({ commit }, params) {
      return new Promise((resolve, reject) => {
        verificationQuery(params).then(res => {
          if (!res) return
          if (res.success) {
            commit('SET_ACCESSTOKENINFO', res.data)
            resolve(res.data)
          }
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default authenticationStore



// WEBPACK FOOTER //
// ./src/store/authenticationStore.js